import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import StepsEnum from "@app/scene/settings/component/Imports/enum/Steps";
import { setStep } from "@app/scene/settings/component/Imports/store/actions";

interface Props {
  setStep: typeof setStep;
}

const ReturnToImport: React.FC<Props> = ({ setStep }) => {
  const intl = useIntl();
  const handleNewImportClick = useCallback(() => {
    setStep(StepsEnum.UPLOAD);
  }, [setStep]);

  return (
    <Button onClick={handleNewImportClick} type="link">
      {intl.formatMessage({
        id: "settings.newImports.finalizeStep.goToNewImport",
        defaultMessage: "New Import",
        description: "Text of GO TO NEW IMPORT button",
      })}
    </Button>
  );
};

const mapDispatchToProps = {
  setStep,
};

export default connect(null, mapDispatchToProps)(ReturnToImport);
